import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { RootReducers } from '../../../redux/reducers'
import * as loginActions from '../../../redux/actions/login.action'
import { requestLoginModel } from '../../../models/login'
import './style.css'
import { HeaderBar, LoginField } from '../../../component'
import { DoubleRing } from '../../../component/loading'
import Modal from 'react-modal'
import bgMB from '../../../assets/images/login-bg-mb.webp'
import bgTablet from '../../../assets/images/login-bg-tablet.webp'
import userIcon from '../../../assets/images/use.svg'
import passwordIcon from '../../../assets/images/password.svg'

export const Login: React.FC = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const loginReducer = useSelector((state: RootReducers) => state.loginReducer)

  const [userId, setUserId] = useState<string>('')
  const [password, setPassword] = useState<string>('')
  const [fwdStaffChecked, setFwdStaffChecked] = React.useState(false)

  const handleFwdStaffCheckedChange = () => {
    setFwdStaffChecked(!fwdStaffChecked)
  }

  const handleChangeId = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value: userId } = event.target
    setUserId(userId)
    setFwdStaffChecked(!isNumeric(userId))
    if (userId === '') {
      setFwdStaffChecked(false)
    }
  }

  const handleChangePassword = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value: password } = event.target
    setPassword(password)
  }

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    const values: requestLoginModel = {
      username: userId,
      password: password,
      isFWDStaff: fwdStaffChecked
    }
    dispatch(loginActions.handleLogin(values, navigate))
  }

  const isNumeric = (str: any): boolean => {
    if (typeof str != 'string') return false // we only process strings!
    return !isNaN(parseInt(str)) && !isNaN(parseFloat(str))
  }

  return (
    <>
      <HeaderBar isLogin />
      <div className="container-login">
        <picture className="background-login">
          <source media="(max-width:390px)" srcSet={bgMB} />
          <img src={bgTablet} alt="login-bg" className="img-login" />
        </picture>
        <div className="content">
          <div className="text-header">เข้าสู่ระบบ e-TR</div>
          <div className="text-login">กรุณากรอกชื่อผู้ใช้งานและรหัสผ่าน</div>
          <form className="form-auth" onSubmit={e => handleSubmit(e)}>
            <LoginField
              placeholder="ชื่อผู้ใช้งาน"
              name="userId"
              value={userId}
              type="text"
              onChange={handleChangeId}
              icon={userIcon}
            />
            <LoginField
              placeholder="รหัสผ่าน"
              name="password"
              value={password}
              onChange={handleChangePassword}
              type="password"
              icon={passwordIcon}
            />
            <div className="container-fwd-staff-checkbox">
              <label className="fwd-staff-checkbox-label">
                <input
                  type="checkbox"
                  checked={fwdStaffChecked}
                  onChange={handleFwdStaffCheckedChange}
                />
                FWD Staff
              </label>
            </div>
            <button
              style={{ width: '100%', fontFamily: 'Noto', fontSize: 16, fontWeight: 600 }}
              type="submit"
              disabled={loginReducer.isFetching}
            >
              เข้าสู่ระบบ
            </button>
            {/* Error Alert */}
            {loginReducer.isError && (
              <span className="login-error">
                {loginReducer.account !== null
                  ? loginReducer.account?.thaiMessage
                  : 'ไม่สามารถเข้าใช้งานแบบซ้ำซ้อนได้'}
              </span>
            )}
          </form>
          <div
            style={{
              width: '100%',
              fontSize: 14,
              fontFamily: 'Noto',
              textAlign: 'center'
            }}
          >
            <a href="https://www.fwd.in.th/" rel="noreferrer" target="_blank">
              ลืมรหัสผ่าน / ปลดล็อค
            </a>
          </div>
        </div>
        <Modal
          isOpen={loginReducer.isFetching}
          className="modal_login"
          overlayClassName="modal_login_Overlay"
          ariaHideApp={false}
        >
          <DoubleRing></DoubleRing>
        </Modal>
      </div>
    </>
  )
}
